import { render, staticRenderFns } from "./index_hot.vue?vue&type=template&id=5f35941f&scoped=true"
import script from "./index_hot.vue?vue&type=script&lang=js"
export * from "./index_hot.vue?vue&type=script&lang=js"
import style0 from "./index_hot.vue?vue&type=style&index=0&id=5f35941f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35941f",
  null
  
)

export default component.exports